import { useNavigate } from 'react-router-dom';

interface CheckInHeaderProps {
  className?: string;
  variant?: 'default' | 'compact';
  onClose?: () => void;
}

export default function CheckInHeader({ className = '', variant = 'default', onClose }: CheckInHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className={`flex items-center justify-between px-4 pt-14 w-full max-w-md lg:max-w-xl mx-auto ${className}`}>
      <h1
        className={
          variant === 'compact'
            ? 'text-[#1B2831] font-bold text-[17px]'
            : 'text-[#1B2831] font-semibold text-2xl'
        }
        style={{
          fontFamily: 'DM Sans',
          letterSpacing: variant === 'compact' ? '-0.68px' : '-0.96px',
        }}
      >
        The weather inside
      </h1>
      <button
        onClick={() => onClose ? onClose() : navigate('/home')}
        className="w-11 h-11 flex items-center justify-center"
        aria-label="Close check-in"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18M6 6l12 12" stroke="#1B2831" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    </div>
  );
}
